























































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarGeneralRecordHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};

  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraPower'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  /*    async getTime() {
         this.ordesList2 = (await this.getTimeSeleccionado()) || [];
         this.data = this.ordesList2[0];
         this.formFields.powerMode.value = parseInt(this.data['?column?'].LittlePowerEnable);
         const on = parseInt(this.data['?column?'].PowerOnTime) / 3600;
         const off = this.convertirSegundosAHora(parseInt(this.data['?column?'].PowerOffTime));
         this.formFields.delayOff.value = parseInt(this.data['?column?'].switch);
         this.formFields.powerOn.value = moment(on, 'HHmm');
         this.formFields.powerOff.value = moment(off, 'HHmm');
         this.formFields.recDelayTime.value = this.data['?column?'].delay;
         this.formFields.autoReboot.value = parseInt(this.data['?column?'].switch);
         this.formFields.rebootTime.value = this.convertirSegundosAHora(parseInt(this.data['?column?'].RebootTime));
         this.formFields.lowVoltagePowOff.value = parseInt(this.data['?column?'].LowPowerOff);
       }
     
       mounted() {
         this.getTime();
       } */
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    preRecording: any;
    preRecordingMinutes: any;
    system: any;
    overWrite: any;
  } = {
    preRecording: {
      label: 'Pre-Recording',
      check: false,
    },
    preRecordingMinutes: {
      label: '',
      value: 0,
      items: [{ label: '15 Min', id: 0 }],
    },
    system: {
      label: 'System',
      value: 0,
      items: [{ label: 'NTSC', id: 0 }],
    },
    overWrite: {
      label: 'OverWrite',
      value: 0,
      items: [{ label: 'By Capacity', id: 0 }],
    },
  };
  selectedSystem() {
    return this.formFields.system.items.find(
      (item: { id: any }) => item.id === this.formFields.system.value
    );
  }
  selectedOverWrite() {
    return this.formFields.overWrite.items.find(
      (item: { id: any }) => item.id === this.formFields.overWrite.value
    );
  }
  selectedPreRecordingMinutes() {
    return this.formFields.preRecordingMinutes.items.find(
      (item: { id: any }) =>
        item.id === this.formFields.preRecordingMinutes.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
